(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-we-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MIN_THUMB_PX = 24;
    const BOUND_ATTR = 'data-we-featured-product-bound';
    const DRAG_THRESHOLD = 10;

    function getScrollStep(track) {
      const item = track.querySelector('.we-featured-product__item');
      if (!item) return track.clientWidth;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return item.offsetWidth + gap;
    }

    function updateProgress(track, progress, fill) {
      if (!track || !progress || !fill) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const canScroll = maxScroll > 1;

      progress.hidden = !canScroll;
      if (!canScroll) return;

      const trackWidth = progress.clientWidth;
      const thumbWidth = Math.max((track.clientWidth / track.scrollWidth) * trackWidth, MIN_THUMB_PX);
      const maxTranslate = Math.max(trackWidth - thumbWidth, 0);
      const ratio = track.scrollLeft / maxScroll;

      fill.style.width = thumbWidth + 'px';
      fill.style.transform = 'translateX(' + ratio * maxTranslate + 'px)';
    }

    function updateNav(track, prevBtn, nextBtn) {
      if (!track || !prevBtn || !nextBtn) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const canScroll = maxScroll > 1;

      prevBtn.disabled = !canScroll || track.scrollLeft <= 1;
      nextBtn.disabled = !canScroll || track.scrollLeft >= maxScroll - 1;
    }

    function getMaxScroll(track) {
      return Math.max(track.scrollWidth - track.clientWidth, 0);
    }

    function setActiveIndex(section, index) {
      const hotspots = section.querySelectorAll('[data-we-featured-hotspot]');

      hotspots.forEach((hotspot) => {
        const hotspotIndex = Number(hotspot.getAttribute('data-product-index'));
        const isActive = hotspotIndex === index;

        hotspot.classList.toggle('is-active', isActive);
        hotspot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }

    function getIndexFromScroll(track) {
      const items = [...track.querySelectorAll('.we-featured-product__item')];
      if (!items.length) return 0;

      const styles = window.getComputedStyle(track);
      const paddingLeft = parseFloat(styles.paddingLeft || '0') || 0;
      const scrollLeft = track.scrollLeft + paddingLeft;

      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft - scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function getTargetScrollLeft(track, item) {
      const trackRect = track.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();
      const styles = window.getComputedStyle(track);
      const scrollPaddingLeft = parseFloat(styles.scrollPaddingLeft || '0') || 0;

      return track.scrollLeft + (itemRect.left - trackRect.left) - scrollPaddingLeft;
    }

    function isItemInView(track, index) {
      const items = track.querySelectorAll('.we-featured-product__item');
      const item = items[index];
      if (!item) return false;

      const trackRect = track.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      return itemRect.left >= trackRect.left - 2 && itemRect.right <= trackRect.right + 2;
    }

    function scrollToIndex(track, index) {
      const items = track.querySelectorAll('.we-featured-product__item');
      const item = items[index];
      if (!item) return;

      const targetLeft = Math.max(0, Math.min(getTargetScrollLeft(track, item), getMaxScroll(track)));
      track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    function bindCardNavigation(track) {
      if (!track || track.getAttribute('data-we-featured-cards-bound') === 'true') return;

      track.setAttribute('data-we-featured-cards-bound', 'true');

      let pointerStart = null;
      let dragged = false;
      let activePointerId = null;

      const resetPointer = () => {
        pointerStart = null;
        activePointerId = null;
      };

      track.addEventListener(
        'pointerdown',
        (event) => {
          if (event.button !== 0) return;

          pointerStart = { x: event.clientX, y: event.clientY };
          dragged = false;
          activePointerId = event.pointerId;
        },
        { passive: true }
      );

      track.addEventListener(
        'pointermove',
        (event) => {
          if (!pointerStart || event.pointerId !== activePointerId) return;

          const dx = Math.abs(event.clientX - pointerStart.x);
          const dy = Math.abs(event.clientY - pointerStart.y);

          if (dx > DRAG_THRESHOLD || dy > DRAG_THRESHOLD) {
            dragged = true;
          }
        },
        { passive: true }
      );

      track.addEventListener('pointerup', (event) => {
        if (event.pointerId !== activePointerId) return;
        resetPointer();
      });

      track.addEventListener('pointercancel', (event) => {
        if (event.pointerId !== activePointerId) return;
        resetPointer();
      });

      track.addEventListener('click', (event) => {
        if (dragged) {
          event.preventDefault();
          dragged = false;
          return;
        }

        if (event.target.closest('a[href], button')) return;

        const card = event.target.closest('[data-plp-card]');
        const url = card?.dataset.productUrl;
        if (url) window.location.assign(url);
      });
    }

    function bindHotspots(section, track) {
      const hotspots = section.querySelectorAll('[data-we-featured-hotspot]');
      if (!hotspots.length) return;

      let activeIndex = getIndexFromScroll(track);
      let scrollTarget = null;
      let scrollEndTimer = null;

      setActiveIndex(section, activeIndex);

      const finishProgrammaticScroll = () => {
        if (scrollTarget === null) return;

        const items = track.querySelectorAll('.we-featured-product__item');
        const item = items[scrollTarget];
        if (!item) {
          scrollTarget = null;
          return;
        }

        const targetLeft = Math.max(0, Math.min(getTargetScrollLeft(track, item), getMaxScroll(track)));
        if (Math.abs(track.scrollLeft - targetLeft) > 3) {
          scheduleProgrammaticScrollEnd();
          return;
        }

        activeIndex = scrollTarget;
        setActiveIndex(section, activeIndex);
        scrollTarget = null;
      };

      const scheduleProgrammaticScrollEnd = () => {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(finishProgrammaticScroll, 50);
      };

      hotspots.forEach((hotspot) => {
        hotspot.addEventListener('click', () => {
          const index = Number(hotspot.getAttribute('data-product-index'));
          if (Number.isNaN(index)) return;
          if (index === activeIndex && isItemInView(track, index)) return;

          scrollTarget = index;
          setActiveIndex(section, index);
          scrollToIndex(track, index);
        });
      });

      track.addEventListener(
        'scroll',
        () => {
          if (scrollTarget !== null) {
            scheduleProgrammaticScrollEnd();
            return;
          }

          const index = getIndexFromScroll(track);
          if (index === activeIndex) return;

          activeIndex = index;
          setActiveIndex(section, index);
        },
        { passive: true }
      );

      if ('onscrollend' in window) {
        track.addEventListener('scrollend', finishProgrammaticScroll, { passive: true });
      }
    }

    function bindSection(section) {
      if (section.getAttribute(BOUND_ATTR) === 'true') return;

      const track = section.querySelector('[data-we-featured-product-track]');
      const progress = section.querySelector('[data-we-featured-product-progress]');
      const fill = section.querySelector('[data-we-featured-product-progress-fill]');
      const nav = section.querySelector('[data-we-featured-product-nav]');
      const prevBtn = section.querySelector('[data-we-featured-product-prev]');
      const nextBtn = section.querySelector('[data-we-featured-product-next]');

      if (!track) return;

      section.setAttribute(BOUND_ATTR, 'true');
      bindCardNavigation(track);
      bindHotspots(section, track);

      track.addEventListener(
        'scroll',
        () => {
          const maxScroll = getMaxScroll(track);
          if (maxScroll > 1 && track.scrollLeft > maxScroll) {
            track.scrollLeft = maxScroll;
          }
        },
        { passive: true }
      );

      const sync = () => {
        const canScroll = track.scrollWidth - track.clientWidth > 1;

        if (nav) {
          nav.hidden = !canScroll;
        }

        updateProgress(track, progress, fill);
        updateNav(track, prevBtn, nextBtn);
      };

      const onScroll = () => {
        updateProgress(track, progress, fill);
        updateNav(track, prevBtn, nextBtn);
      };

      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -getScrollStep(track), behavior: 'smooth' });
      });

      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: getScrollStep(track), behavior: 'smooth' });
      });

      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', sync);
      document.addEventListener('theme:resize:width', sync);

      sync();
    }

    function init(root) {
      root.querySelectorAll('[data-we-featured-product]').forEach(bindSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches?.('[data-we-featured-product]')
        ? event.target
        : event.target.querySelector?.('[data-we-featured-product]');

      if (!section) return;

      section.removeAttribute(BOUND_ATTR);
      section.querySelector('[data-we-featured-product-track]')?.removeAttribute('data-we-featured-cards-bound');
      bindSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
